// Importing Packages - Plugins
import { createApp, ref } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'
import VueProgressBar from "@aacassandra/vue3-progressbar";

// Importing Components
import SetNewPassword from '../components/SetNewPassword.vue'
import Login from '../components/Login.vue'

// Import language translations
import { languages } from '../../translations/index.js'

// Combine all languages into a single object
const messages = Object.assign(languages);

// Get the language of the site
const siteLang = document.documentElement.lang;

// Options for the progress bar
const options = {
    color: "#ffcf2c",
    failedColor: "#874b4b",
    thickness: "5px",
};

// Wait for the DOM to load
document.addEventListener('DOMContentLoaded', () => {
    const i18n = createI18n({
        legacy: false,
        warnHtmlMessage: false,
        locale: siteLang,
        messages
    });

    // Create a router instance
    const router = createRouter({
        history: createWebHashHistory(),
        routes: [
            {
                path: '/set-new-password',
                name: 'Set New Password',
                component: SetNewPassword,
            }
        ]
    });

    // Create a Vue app instance
    const app = createApp({
        setup() {
            const modalAccessAgreement = ref(false);

            const login = (e) => {
                if (e) {
                    window.location = "/Home/Index";
                }
            }
            return {
                modalAccessAgreement,
                login
            }
        }
    });

    // Use the router, i18n, and progress bar in the app
    app.use(router);
    app.use(i18n);
    app.use(VueProgressBar, options);

    // Register the Login component globally
    app.component('Login', Login);

    // Mount the app to the DOM
    app.mount('#app');
}, false);